import React, {useEffect, useState} from 'react';
import see from "../../images/see.svg";
import hide from "../../images/Hide.svg";
export default function PasswordInput(props) {
    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false);
    const showPassword = e => {
        setShowPass(true)
    }
    const hidePassword = e => {
        setShowPass(false)
    }
    const passwordHandler = e => {
        props.setPassword(e)
        setPassword(e.target.value)
    }
    return (
      <div className="password">
          <input name="password" onKeyDown={props.enterKey} className={`mt-3 mr-0 ${(password && !showPass) && 'star'}`} placeholder={props.placeHolder ? props.placeHolder : 'Enter Your Password'} onChange={passwordHandler}  type={showPass ? 'text' : 'password'}/>
          <img style={showPass ? {marginTop:-1} : {}}  onMouseDown={ showPassword } onMouseUp={ hidePassword } onMouseLeave={ hidePassword } className="see" src={showPass ? hide : see} alt="see password" draggable={false}/>
      </div>
    );
}
